(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-review-carousel"] && !Shopify.designMode) return;
  try {
    
  function initializeWanReviewCarousels(scope) {
    const root = scope || document;
    const sections = root.querySelectorAll('.wan-reviews');

    sections.forEach(function(section) {
      if (section.dataset.autoplayInitialized === 'true') return;
      section.dataset.autoplayInitialized = 'true';

      const carousel = section.querySelector('[data-review-carousel]');
      if (!carousel) return;

      let autoplayTimer;
      let restartTimer;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function reviewDistance() {
        const firstCard = carousel.querySelector('.wan-review-card');
        if (!firstCard) return Math.max(300, carousel.clientWidth * 0.82);
        const gap = parseFloat(window.getComputedStyle(carousel).columnGap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      }

      function advanceReviews() {
        const reachedEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 12;
        if (reachedEnd) {
          carousel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          carousel.scrollBy({ left: reviewDistance(), behavior: 'smooth' });
        }
      }

      function stopAutoplay() {
        window.clearInterval(autoplayTimer);
      }

      function startAutoplay() {
        if (reducedMotion) return;
        stopAutoplay();
        autoplayTimer = window.setInterval(advanceReviews, 3500);
      }

      function pauseTemporarily() {
        stopAutoplay();
        window.clearTimeout(restartTimer);
        restartTimer = window.setTimeout(startAutoplay, 6500);
      }

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', startAutoplay);
      carousel.addEventListener('pointerdown', pauseTemporarily);
      carousel.addEventListener('touchstart', pauseTemporarily, { passive: true });

      startAutoplay();
    });
  }

  document.addEventListener('click', function(event) {
    const previous = event.target.closest('[data-review-previous]');
    const next = event.target.closest('[data-review-next]');
    const button = previous || next;
    if (!button) return;
    const section = button.closest('.wan-reviews');
    const carousel = section ? section.querySelector('[data-review-carousel]') : null;
    if (!carousel) return;
    const distance = Math.max(300, carousel.clientWidth * 0.82);
    carousel.scrollBy({ left: previous ? -distance : distance, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeWanReviewCarousels(document);
    });
  } else {
    initializeWanReviewCarousels(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeWanReviewCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      const searchModal = this.header.querySelector('details-modal');
      if (searchModal && typeof searchModal.close === 'function') {
        searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (window.matchMedia('(min-width: 990px)').matches) {
    document.querySelectorAll('header-menu').forEach(function(menu) {
      var details = menu.querySelector('details');
      if (!details) return;
      var timeout;

      menu.addEventListener('mouseenter', function() {
        clearTimeout(timeout);
        details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', function() {
        timeout = setTimeout(function() {
          details.removeAttribute('open');
        }, 150);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-proofs"] && !Shopify.designMode) return;
  try {
    
  function initializeWanRealProofs(scope) {
    scope.querySelectorAll('[data-wan-real-proofs]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const track = section.querySelector('[data-proof-track]');
      const cards = Array.from(section.querySelectorAll('[data-proof-card]'));
      const dots = Array.from(section.querySelectorAll('[data-proof-dots] span'));
      const previous = section.querySelector('[data-proof-previous]');
      const next = section.querySelector('[data-proof-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Number(section.dataset.autoplay) || 4000;
      let activeIndex = 0;
      let timer;
      let resumeTimer;

      if (!track || cards.length === 0) return;

      const setActive = (index) => {
        activeIndex = (index + cards.length) % cards.length;
        cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === activeIndex));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
      };

      const goTo = (index) => {
        setActive(index);
        const activeCard = cards[activeIndex];
        const cardLeft = activeCard.offsetLeft - track.offsetLeft;
        const centeredLeft = cardLeft - (track.clientWidth - activeCard.offsetWidth) / 2;
        track.scrollTo({
          left: Math.max(0, centeredLeft),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (!reducedMotion && cards.length > 1) timer = window.setInterval(() => goTo(activeIndex + 1), interval);
      };
      const pauseThenResume = () => {
        stop();
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(start, interval * 2);
      };

      previous?.addEventListener('click', () => { goTo(activeIndex - 1); pauseThenResume(); });
      next?.addEventListener('click', () => { goTo(activeIndex + 1); pauseThenResume(); });
      track.addEventListener('pointerdown', pauseThenResume);
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);

      let scrollTimer;
      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const center = track.scrollLeft + track.clientWidth / 2;
          let closest = 0;
          let distance = Infinity;
          cards.forEach((card, index) => {
            const cardCenter = card.offsetLeft + card.offsetWidth / 2;
            const currentDistance = Math.abs(center - cardCenter);
            if (currentDistance < distance) {
              distance = currentDistance;
              closest = index;
            }
          });
          setActive(closest);
        }, 80);
      }, { passive: true });

      setActive(0);
      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWanRealProofs(document));
  } else {
    initializeWanRealProofs(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeWanRealProofs(event.target));

  } catch(e) { console.error(e); }
})();
})();
